export const ButtonsProp = Object.freeze({
    Buttons: 'buttons',
});